import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Footer {
	constructor() {
		this.footerContainer = document.querySelector('#footer-container')
		this.footer = document.querySelector('footer')
		if (!this.footer || !this.footerContainer) return

		this.tl = null

		this.#init()
	}

	#init() {
		this.tl = gsap
			.timeline({
				scrollTrigger: {
					trigger: this.footerContainer,
					start: 'top bottom',
					end: () => {
						const containerHeight = this.footerContainer.offsetHeight
						const screenHeight = window.innerHeight
						if (containerHeight > screenHeight) {
							return `+=${screenHeight}`
						}
						return 'bottom +=100%'
					},
					scrub: true,
				},
				defaults: {
					ease: 'none',
				},
			})
			.from(this.footer, { yPercent: -50 })
	}

	destroy() {
		if (this.tl) this.tl.scrollTrigger?.kill()
	}
}
